
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"23.101","y":"14.104","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M15.48 23.946l4.743-17.551h1.073L15.85 25.604h-.103l-.266-1.658zm-1.913-5.727l2.249 5.727-.115 1.658h-.11l-2.98-7.385h.956zm-2.531.904v-.904H13.5v.904h-2.464z","fill":"currentColor"}}),_c('path',{attrs:{"fill":"currentColor","d":"M20.368 6.395h16.831v.804H20.368z"}})])
          )
        }
      }
    